export const APP_VERSION = '2.0.0';
export const API_BASE_URL = '/api';
export const ENABLE_REDUX_LOGGER = false;
export const PLATFORM_NAME = 'MERCHANT_WEB';

export default {};
